module.exports = __webpack_public_path__ + "static/media/hublocal-logo.81cd7142.png";